import script from "/app/pages/Home/invoice_list.vue?type=script";
import "/app/pages/Home/invoice_list.vue?type=style";
import { render } from "/app/pages/Home/invoice_list.vue?type=template";
script.render = render;
export default script;
